import { useReveal } from "@/lib/useReveal";

const reasons = [
  {
    num: "01",
    title: "Scientifically Validated",
    body:
      "Every product begins from clinical insight, supported by peer-reviewed evidence and continuously measured against real outcomes.",
  },
  {
    num: "02",
    title: "Privacy-First by Design",
    body:
      "Patient privacy is not a feature. It’s an architecture decision, present in every schema, request, and audit trail.",
  },
  {
    num: "03",
    title: "Dual-Domain Expertise",
    body:
      "A founding team fluent in both medicine and modern engineering, translating clinical complexity into elegant software.",
  },
  {
    num: "04",
    title: "Agile & Product-Led",
    body:
      "We build like a product company and ship like a clinical organisation, fast iteration, validated against rigour.",
  },
  {
    num: "05",
    title: "South India First",
    body:
      "Designed for the realities of our home region first, calibrated to the systems, languages, and infrastructure of South India.",
  },
];

export default function Why() {
  const ref = useReveal();
  return (
    <section
      id="why"
      data-testid="why-section"
      ref={ref}
      className="relative bg-[#F8F9FA] py-28 md:py-44"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-[#5F6368] reveal">
          <span className="inline-block h-px w-10 bg-[#D62828]" />
          Why Blude TechX
        </div>

        <div className="mt-8 grid grid-cols-12 gap-8 items-end">
          <h2 className="col-span-12 lg:col-span-9 font-display text-[clamp(2.25rem,5vw,5rem)] leading-[0.95] tracking-[-0.035em] text-[#111111] reveal">
            Five reasons leading clinicians and{" "}
            <span className="font-serif-italic italic text-[#D62828]">
              health systems
            </span>{" "}
            partner with us.
          </h2>
        </div>

        <div className="mt-20 md:mt-28 divide-y divide-[#CED4DA] border-y border-[#CED4DA]">
          {reasons.map((r) => (
            <div
              key={r.num}
              data-testid={`reason-${r.num}`}
              className="reveal group relative grid grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 hover:bg-white transition-colors duration-700"
            >
              <div className="col-span-12 md:col-span-3 lg:col-span-2 relative">
                <span
                  className="font-display block text-[#CED4DA] group-hover:text-[#D62828] transition-colors duration-700 leading-none tracking-tighter"
                  style={{ fontSize: "clamp(4rem, 9vw, 8rem)" }}
                >
                  {r.num}
                </span>
              </div>
              <h3 className="col-span-12 md:col-span-4 lg:col-span-4 font-display text-[clamp(1.5rem,2.5vw,2.25rem)] tracking-[-0.03em] leading-[1.05] text-[#111111] self-center">
                {r.title}
              </h3>
              <p className="col-span-12 md:col-span-5 lg:col-span-6 text-[15px] leading-[1.75] text-[#5F6368] self-center max-w-2xl">
                {r.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
